export const wijs = [
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Info voor de leraar</h2>\n<h3 class="ck5h3">Inhoudelijk&nbsp;</h3>\n<p>Deze les gaat over mensen- en kinderrechten. De leerlingen activeren in het eerste deel van de les hun voorkennis aan de hand van enkele opdrachten. Hierna gaan ze dieper in op de schending van die rechten en zetten ze een eerste stap tot systeemdenken.</p>\n<h3 class="ck5h3">Praktisch&nbsp;</h3>\n<p>Voor deze les zullen de leerlingen een koptelefoon/oortjes nodig hebben.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2123708',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 1,
    time: null,
    title: 'Info voor de leraar',
    viewModes: ['PROJECTION'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">WIJS! - iedereen gelijk?</h3>\n  <h2 class="dotted-in-editor">Les 1 - Het complexe systeem van mensen- en kinderrechten</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e92191d9af994beeb1766baa979a977f.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116795',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 2,
    time: null,
    title: 'Les 1 - Het complexe systeem van mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Voorbereiding</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/3b07247f526248f8b8dd9c880ce2493d.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116797',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 3,
    time: null,
    title: 'Voorbereiding',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Over de les</h2>\n<p><iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="100%" name="undefined" src="https://player.vimeo.com/video/913239740" title="" width="100%">&nbsp;</iframe></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116800',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 4,
    time: null,
    title: 'Over de les',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Over de les</h2>\n<ol>\n <li><u>Mensen- en kinderrechten (15-20 minuten)</u></li>\n</ol>\n<p style="margin-left:40px;">1.1 Mensenrechten algemeen</p>\n<p style="margin-left:40px;">1.2 Kinderrechten algemeen</p>\n<ol start="2">\n <li><u>Schending van mensen- en kinderrechten (45-55 minuten)</u></li>\n</ol>\n<p style="margin-left:40px;">2.1 Worden onze rechten overal nageleefd?</p>\n<p style="margin-left:40px;">2.2 Leerling-expert aan het woord</p>\n<p>&nbsp; <u>Test jezelf! (5 minuten)</u></p>\n<p>&nbsp; <u>Reflectie (5 minuten)</u></p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2118641',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 5,
    time: null,
    title: 'Over de les',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div>\n <h2 class="dotted-in-editor">Over de les - Leerdoelen</h2>\n <div class="learnContainer">\n  <div class="mainContent dotted-in-editor">\n   <h3 class="ck5h3">Na deze les kan je…</h3>\n   <div class="check-list">\n    <ul>\n     <li>beschrijven wat mensen- en kinderrechten zijn.</li>\n     <li>toelichten dat mensen- en kinderrechten deel zijn van een groter systeem, waarin verschillende belangen soms met elkaar botsen.</li>\n     <li>geïnformeerd een standpunt innemen over kinderrechten.</li>\n    </ul>\n   </div>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <div class="ftrprfLogo">\n    &nbsp;\n   </div>\n  </div>\n  <div class="dotted-in-editor imagePlaceholder">\n   <span><strong><img class="image_resized" style="width:380px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ccab545807814205b8ad7edc30ff00ee.jpg" alt=""></strong></span>\n  </div>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116802',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 6,
    time: null,
    title: 'Over de les - Leerdoelen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">1. Mensen- en kinderrechten</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/c0548430c7e34eb2aebe1f41de5ba093.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116796',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 7,
    time: null,
    title: '1. Mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1. Mensen- en kinderrechten</h2>\n <h3 class="ck5h3">Waarom zijn mensen- en kinderrechten belangrijk?</h3>\n <ul>\n  <li>Bekijk de video die je in de blauwe knop vindt.</li>\n  <li>Denk na over de titelvraag van deze module: Iedereen gelijk?</li>\n </ul>\n <p style="text-align:center;"><a class="styledLink SlideViewer__StyledButton SlideViewer__VideoLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.youtube.com/watch?v=eJ3mOQaA5nE">&nbsp;Iedereen gelijk?&nbsp;</a>&nbsp;</p>\n <p class="title-with-background title-with-background--statement" style="text-align:center;">Geef één voorbeeld waarbij gelijk zijn belangrijk is en geef één voorbeeld waarbij verschillend zijn juist goed is.</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117304',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '368262',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 8,
    time: null,
    title: '1. Intro: Mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1. Mensen- en kinderrechten</h2>\n <h3 class="ck5h3">Waar ga jij deze les mee aan de slag?</h3>\n <p><img class="image_resized image-style-align-left" style="width:380px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/c61b8a945d454e4797521b9ed02ba49b.jpg"></p>\n <p>&nbsp;</p>\n <p>&nbsp;</p>\n <p>In dit deel van de les werk je rond mensen- en kinderrechten. De basis van deze rechten zegt dat iedereen gelijk is. Uit de video op de vorige slide blijkt dat dit nog niet het geval is.&nbsp;</p>\n <p>In de eerste drie opdrachten van de les fris je jouw kennis over mensen- en kinderrechten op. Hierna verdiep je jou in het naleven van deze rechten.</p>\n <p>→ 1.1 Mensenrechten</p>\n <p>→ 1.2 Van mensenrechten naar kinderrechten</p>\n <p>→ 1.3 Kinderrechten</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117305',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 9,
    time: null,
    title: '1. Intro: Mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.1 mensenrechten</h2>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Na deze opdracht kan je beschrijven wat mensenrechten zijn.</td>\n     <td style="width:40%;">5-10 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>In deze opdracht leer je mensenrechten op een heel laagdrempelige manier kennen.</p>\n <ul>\n  <li>Bekijk de video.</li>\n  <li>Beantwoord de vragen.</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117306',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 10,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p><iframe allowfullscreen class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="100%" src="https://www.youtube.com/embed/njJ5Xjp9f1I?end=61" title="" width="100%"> </iframe></p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p>Wanneer je een video moet kijken en erna vragen over de inhoud moet beantwoorden, is het handig om op voorhand de vragen al eens te lezen. Op deze manier kan je tijdens het kijken al gericht zoeken naar de antwoorden.</p><p><strong>De vragen die bij deze video horen zijn:</strong></p><ol style="list-style-type:decimal;"><li>Wanneer zijn de basisrechten van de mens vastgelegd in de universele verklaring voor de rechten van de mens?</li><li>Welke organisatie heeft de universele verklaring voor de rechten van de mens opgesteld?</li><li>Voor wie gelden de mensenrechten?</li><li>Hoeveel mensenrechten zijn er?</li><li>Wat is de basis voor de andere rechten?</li></ol>',
        id: '4311',
        title: 'Hoe kan je gericht een video bekijken?',
      },
    ],
    id: '2117307',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 11,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 1: Wanneer zijn de basisrechten van de mens vastgelegd in de Universele Verklaring voor de Rechten van de Mens?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117308',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350196',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution:
          'De universele verklaring van de rechten van de mens is er gekomen na de Tweede Wereldoorlog.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 12,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 2: Welke organisatie heeft de Universele Verklaring voor de Rechten van de Mens opgesteld?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117309',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350197',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution:
          'De universele verklaring voor de rechten van de mens is opgesteld door de Verenigde Naties.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 13,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 3: Voor wie gelden de mensenrechten?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117310',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350198',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: 'De mensenrechten gelden voor iedereen, altijd en overal.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 14,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 4: Hoeveel mensenrechten zijn er?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117311',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350199',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: 'De mensenrechten zijn vastgelegd in 30 artikelen.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 15,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 5: Wat is het eerste artikel in de mensenrechtenverklaring, dat de basis vormt voor alle andere artikels?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117312',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350200',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: 'Iedereen wordt gelijk geboren.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 16,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Mensenrechten</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 6: Leg aan de hand van het recht op onderwijs uit waarom het eerste artikel de basis hiervoor vormt.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2128845',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352287',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: 'Iedereen wordt gelijk geboren.',
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 17,
    time: null,
    title: '1.1 Oefenen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/063834447ba34ae8ad0189dec904ea48.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.1 Mensenrechten</h2>\n <div class="OutlineElement Ltr SCXW192783892 BCX0">\n  <p class="">Na de Tweede Wereldoorlog hebben de <strong>Verenigde Naties</strong> in <strong>1948 </strong>de basisrechten van elke mens vastgelegd in de <strong>Universele Verklaring van de Rechten van de Mens</strong>. De rechten van de mens zijn vastgelegd in&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="30 artikelen" data-modal-title="De 30 artikelen van de Universele Verklaring van de Rechten van de Mens" data-modal-size="L" data-modal-content="<figure class=&quot;image&quot;><img style=&quot;aspect-ratio:3413/1646;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images%2Fe112d23a516b405c86afbc67755190a2.png&quot; width=&quot;3413&quot; height=&quot;1646&quot;></figure>"> 30 artikelen&nbsp;</a> .</p>\n  <p class="Paragraph SCXW192783892 BCX0 SlideViewer__Badge info" style="margin-left:0;"><strong>DEFINITIE</strong><br><span class="TextRun SCXW192783892 BCX0 NormalTextRun"><strong>Mensenrechten </strong>zijn rechten die álle mensen over de hele wereld hebben,</span><br><span class="TextRun SCXW192783892 BCX0 NormalTextRun">ongeacht hun geslacht, etnische afkomst, godsdienst of politieke overtuiging.&nbsp;</span><span class="EOP SCXW192783892 BCX0">&nbsp;</span></p>\n  <p class="Paragraph SCXW192783892 BCX0" style="margin-left:0;"><span class="TextRun SCXW192783892 BCX0 NormalTextRun">De mensenrechten zijn vastgelegd in de Grondwet van België en er zijn internationale afspraken over gemaakt. Het is de bedoeling dat de mensenrechten iedereen beschermen en ervoor zorgen dat mensen een goed leven kunnen leiden.&nbsp;</span></p>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116809',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 18,
    time: null,
    title: '1.1 Kennen: Mensenrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.2 van mensenrechten naar kinderrechten</h2>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Na deze opdracht kan je een standpunt innemen over een stelling.</td>\n     <td style="width:40%;">2-5 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>Mening gevraagd!</p>\n <ul>\n  <li>Lees de stelling op de volgende slide en geef jouw mening.</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121148',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 19,
    time: null,
    title: '1.2 Oefenen: Van mensenrechten naar kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.2 Van mensenrechten naar kinderrechten</h2>\n<h3 class="ck5h3">Wat vind jij van deze uitspraak?</h3>\n<p class="title-with-background title-with-background--statement" style="text-align:center;">Zolang kinderen jonger zijn dan 18 jaar moeten ze geen mening hebben en zich niet moeien in volwassen discussies.</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121146',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351034',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 20,
    time: null,
    title: '1.2 Oefenen: Van mensenrechten naar kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.2 Kinderrechten</h2>\n <h3 class="ck5h3">Waarom zijn kinderrechten erbij gekomen?</h3>\n <p>Heel veel zaken vind je misschien vanzelfsprekend in jouw leven,&nbsp;<br>maar het is lang niet zo dat kinderen en jongeren overal ter wereld…</p>\n <figure class="image image_resized image-style-align-right" style="width:380px;">\n  <img style="aspect-ratio:3911/4889;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/c07a05c7ea8041ccaf0ad748ec6a1983.jpg" width="3911" height="4889">\n </figure>\n <ul>\n  <li>hun eigen mening mogen geven.&nbsp;</li>\n  <li>op de eerste plaats komen.</li>\n  <li>toegang hebben tot informatie.</li>\n  <li>naar school kunnen gaan.</li>\n  <li>…</li>\n </ul>\n <p>Kinderen zijn een extra kwetsbare groep in onze maatschappij. Daarom zijn er bovenop de mensenrechten ook nog kinderrechten ontstaan die deze groep beschermen.</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116887',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 21,
    time: null,
    title: '1.2 Lezen: Van mensenrechten naar kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.3 Kinderrechten algemeen</h2>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Na deze opdracht kan je beschrijven wat kinderrechten zijn.</td>\n     <td style="width:40%;">5-10 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>In deze opdracht leer je kinderrechten op een heel laagdrempelige manier kennen.</p>\n <ul>\n  <li>Bekijk het document of de website.</li>\n  <li>Beantwoord de vragen.</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120849',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 22,
    time: null,
    title: '1.3 Oefenen: Kinderrechten algemeen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.3 Kinderrechten algemeen</h2>\n<p>Lees <strong>van Verklaring tot Verdrag</strong> op&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="pagina 6" data-modal-title="pagina 6" data-modal-size="M" data-modal-content="<p class=&quot;SlideViewer__Badge warning&quot;><strong>OPGELET</strong><br>Omdat de eerste twee pagina\'s niet genummerd zijn, is pagina 6 eigenlijk pagina 8 in het pdf-bestand.</p>"> pagina 6&nbsp;</a> van dit document:&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://codefeverpublic.blob.core.windows.net/public-content/documents/9c33bfec82124622aa7d7c571d8f3e31.pdf"> Brochure kinderrechten</a>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 1: Waarom is het kinderrechtenverdrag er gekomen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116814',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350046',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 23,
    time: null,
    title: '1.3 Oefenen: Kinderrechten algemeen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.3 Kinderrechten algemeen</h2>\n<p>Surf naar deze&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.unicef.be/nl/de-bestaansreden-van-unicef/het-kinderrechtenverdrag"> website&nbsp;</a>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 2: Wanneer is het kinderrechtenverdrag opgesteld?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116815',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350047',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 24,
    time: null,
    title: '1.3 Oefenen: Kinderrechten algemeen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.3 kinderrechten algemeen</h2>\n<p>Surf naar deze&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.unicef.be/nl/de-bestaansreden-van-unicef/het-kinderrechtenverdrag"> website&nbsp;</a>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 3: Welke organisatie stelde het kinderrechtenverdrag op?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116816',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350048',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 25,
    time: null,
    title: '1.3 Oefenen: Kinderrechten algemeen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/063834447ba34ae8ad0189dec904ea48.png" alt="">\n </div>\n <h2 class="dotted-in-editor">1.3 kinderrechten</h2>\n <p class="SlideViewer__Badge info"><strong>DEFINITIE</strong><br><strong>Kinderrechten </strong>zijn rechten waar elk kind (vanaf de geboorte tot 18 jaar) recht op heeft.&nbsp;</p>\n <p>Op <strong>20 november 1989</strong> werd het Kinderrechtenverdrag in leven geroepen door de <strong>Verenigde Naties (VN)</strong>.</p>\n <p><span class="EOP SCXW179658422 BCX0">Het Kinderrechtenverdrag is ontstaan uit de Universele Verklaring van de Rechten van de Mens. Aangezien kinderen en jongeren zeer kwetsbaar zijn, moesten er extra duidelijke afspraken gemaakt worden. Deze afspraken zijn vastgelegd in het Kinderrechtenverdrag.&nbsp;</span></p>\n <p><span class="TextRun SCXW179658422 BCX0 NormalTextRun">Door dit verdrag worden de rechten van kinderen wereldwijd beschermd. Het werd</span>&nbsp;&nbsp;&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label=" geratificeerd" data-modal-title="Wat betekent ratificeren" data-modal-size="M" data-modal-content="<ul><li>Wanneer je als land een verdrag <strong>ratificeert</strong>, betekent dit dat het vanaf dan goedgekeurd is en dus geldt als wet.</li><li>Wanneer je als land een verdrag <strong>ondertekent </strong>geldt het dus nog niet als wet.</li></ul><p>→ In het geval van het Kinderrechtenverdrag heeft elk land in de wereld het ondertekend, maar de Verenigde Staten zijn de enige die het nog niet als wet laten gelden. In alle 196 andere landen geldt dit verdrag wel als wet.</p>"> geratificeerd</a>&nbsp; <span class="TextRun SCXW179658422 BCX0 NormalTextRun">door bijna alle landen in de wereld (196 landen).&nbsp;</span><span class="EOP SCXW179658422 BCX0"> Enkel de Verenigde Staten heeft dit nog niet gedaan.</span></p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p>Wist je dat het Kinderrechtenverdrag uit 54 artikels bestaat?</p><p>Van die 54 artikels zijn er <strong>41 kinderrechten</strong>.<br>De verschillende rechten kunnen opgedeeld worden in&nbsp;&nbsp;&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label=" drie catgorieën" data-modal-title="In welke drie categorieën worden kinderrechten opgedeeld?" data-modal-size="M" data-modal-content="&lt;ul&gt;&lt;li&gt;Een deel van de kinderrechten beschrijft welke voorzieningen er allemaal moeten zijn om ervoor te zorgen dat een kind goed kan leven, zich te ontwikkelen en om veilig op te groeien.&lt;/li&gt;&lt;li&gt;Ten tweede zijn er kinderrechten die kinderen moeten beschermen tegen risico\'s en gevaren.&lt;/li&gt;&lt;li&gt;De derde categorie van kinderrechten bevat rechten die ervoor moeten zorgen dat kinderen betrokken worden en hun mening kunnen geven.&lt;/li&gt;&lt;/ul&gt;"> drie catgorieën</a>&nbsp; .</p>',
        id: '4298',
        title: 'Wist je dat?',
      },
    ],
    id: '2116867',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 26,
    time: null,
    title: '1.3 Kennen: Kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor"><span class="text-small">2. naleven van mensen- en kinderrechten</span></h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/c0548430c7e34eb2aebe1f41de5ba093.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120457',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 27,
    time: null,
    title: '2. Naleven van mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2. naleven van mensen- en kinderrechten</h2>\n<h3 class="ck5h3">Wat denk jij?</h3>\n<p class="title-with-background title-with-background--question">Worden rechten overal nageleefd?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120458',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351036',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1129103',
            numbering: null,
            value: '<p>Ja</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1129104',
            numbering: null,
            value: '<p>Nee</p>',
          },
        ],
        scorePerCorrectAnswer: '0',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 28,
    time: null,
    title: '2. Intro: Naleven van mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2. naleven van mensen- en kinderrechten</h2>\n<h3 class="ck5h3">Er is nog veel ongelijkheid en onrechtvaardigheid.</h3>\n<p>Het mensenrechtenverdrag en het kinderrechtenverdrag hebben al veel goedgemaakt, maar toch worden de wetten niet altijd nageleefd.&nbsp;</p>\n<p>Er zijn nog steeds …</p>\n<ul>\n <li>oorlogen.</li>\n <li>kinderen die niet naar school kunnen</li>\n <li>mensen die in slechte omstandigheden moeten werken.</li>\n <li>…</li>\n</ul>\n<p class="title-with-background title-with-background--question">Hoe kan het dat de rechten nog niet altijd nageleefd worden?</p>\n<p>In dit deel van de les zal je ondervinden dat de maatschappij complex in elkaar zit!</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121174',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 29,
    time: null,
    title: '2. Intro: Naleven van mensen- en kinderrechten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:403/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" width="403" height="401">\n </div>\n <h2 class="dotted-in-editor">2.1 Worden onze rechten overal nageleefd?</h2>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Na deze opdracht kan je een situatie analyseren vanuit verschillende standpunten.</td>\n     <td style="width:40%;">10-15 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>In deze opdracht ga je aan de slag met de situatie rond de kobaltmijnen in Congo.</p>\n <ul>\n  <li>Lees op de volgende slide eerst aandachtig waarover het gaat.</li>\n  <li>Los de verschillende vragen op.&nbsp;</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116883',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 30,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.1 Worden onze rechten overal nageleefd?</h2>\n<figure class="image image_resized image-style-align-right" style="width:506px;">\n <img style="aspect-ratio:2644/2644;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/df0e7059eb8a496f9ca303db98fd9c0b.jpg" width="2644" height="2644">\n</figure>\n<h3 class="ck5h3">Zelf een situatie onder de loep nemen.</h3>\n<p>&nbsp;</p>\n<p>Bekijk volgende Instagram post van&nbsp;&nbsp;&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.instagram.com/p/C0UFLnUI0Ww/?img_index=1"> nws.nws.nws</a>&nbsp;.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116941',
    info: null,
    method: null,
    module: null,
    motivation:
      'Laat de post in een 2e tabblad openstaan. Op die manier kan je hem bekijken terwijl je de vragen oplost.',
    part: null,
    questions: [],
    sequence: 31,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.1 Worden onze rechten overal nageleefd?</h2>\n<h3 class="ck5h3">Zelf een situatie onder de loep nemen.</h3>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vat de situatie samen in 1 zin.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116942',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350082',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 32,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:403/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" width="403" height="401">\n </div>\n <h2 class="dotted-in-editor">2.1 Worden onze rechten overal nageleefd?</h2>\n <h3 class="ck5h3">Zelf een situatie onder de loep nemen</h3>\n <p>&nbsp;</p>\n <figure class="image image_resized image-style-align-left" style="width:506px;">\n  <img style="aspect-ratio:3456/2304;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e4c6df4731b047278ef802885b7204f8.jpg" width="3456" height="2304">\n </figure>\n <p>Dit was waarschijnlijk geen makkelijke opdracht. Je kan een situatie zo groot als deze niet in 1 zin samenvatten.</p>\n <p>Eén iets is heel duidelijk: er worden mensen- en kinderrechten geschonden. Wat de oorzaak ervan is en hoe de situatie in elkaar zit, is een complex vraagstuk en vraagt een grondige analyse.&nbsp;</p>\n <p>Beantwoord de vragen op de volgende slides om de situatie volledig te ontleden.</p>\n <p>&nbsp;</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121221',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 33,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 1: Over welke grondstof gaat het?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121223',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351054',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 34,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 2: Komt kobalt veel voor in de wereld als natuurlijke grondstof?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121224',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351055',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 35,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 3: Welke verschillende partijen zijn allemaal betrokken bij deze situatie?<br>Wie ondervindt hier gevolgen van?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121240',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351064',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 36,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 4: Wat is volgens jou het voordeel van het bezitten van de kobaltmijnen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121226',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351057',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 37,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 5: Hoe beïnvloeden (overheids)bedrijven de Congolese bevolking met het uitbreiden van de kobaltmijnen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121243',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351067',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 38,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 6: Hoe beïnvloeden (overheids)bedrijven het milieu met het uitbreiden van de kobaltmijnen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121225',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351056',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 39,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 7: Hoe beïnvloedt deze situatie jou?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121312',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351075',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 40,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 worden onze rechten overal nageleefd?</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 8: Hoe beïnvloed jij de situatie?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121341',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351086',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 41,
    time: null,
    title: '2.1 Oefenen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:403/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" width="403" height="401">\n </div>\n <h2 class="dotted-in-editor">2.1 worden onze rechten overal nageleefd?</h2>\n <p>Je hebt nu een zeer complexe situatie geanalyseerd.&nbsp;</p>\n <ul>\n  <li>STAP 1: Verkennen van de algemene situatie.</li>\n  <li>STAP 2: Wie is allemaal betrokken?</li>\n  <li>STAP 3: Wat zijn de&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label=" belangen" data-modal-title="Hoe kan je de verschillende belangen in kaart brengen?" data-modal-size="L" data-modal-content="<p class=&quot;SlideViewer__Badge info&quot;><strong>DEFINITIE</strong><br>Via een <strong>PESTLE-analyse</strong> kan je de verschillende belangen van partijen die betrokken zijn bij een maatschappelijk probleem in kaart brengen.</p><p></p><p></p>"> belangen</a>&nbsp;van de betrokken partijen?</li>\n  <li>STAP 4: Welke invloed hebben de verschillende belangen op de betrokken partijen?</li>\n </ul>\n <p>Dit is een eerste stap tot&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label=" systeemdenken " data-modal-title="Wat is systeemdenken?" data-modal-size="M" data-modal-content="<figure class=&quot;image image_resized&quot; style=&quot;width:886px;&quot;><img style=&quot;aspect-ratio:4625/2470;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/f6dfbf43b3f04d54a3378406a31dd106.png&quot; width=&quot;4625&quot; height=&quot;2470&quot;></figure>"> systeemdenken</a>&nbsp;. Het houdt in dat je situaties bekijkt vanuit verschillende standpunten. Je bekijkt wie de partijen zijn, wat hun belangen zijn en hoe ze elkaar beïnvloeden. Op deze manier heb je een brede kijk op de situatie.</p>\n <p>&nbsp;</p>\n <p>&nbsp;</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2121247',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 42,
    time: null,
    title: '2.1 Lezen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:403/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/487b26dd726f4212befa149203de51cc.png" width="403" height="401">\n </div>\n <h2 class="dotted-in-editor">2.1 worden onze rechten overal nageleefd?</h2>\n <h3 class="ck5h3">PESTLE-analyse kobaltmijnen Congo</h3>\n <figure class="table">\n  <table>\n   <tbody>\n    <tr>\n     <td>&nbsp;</td>\n     <td style="text-align:center;vertical-align:bottom;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Politiek" data-modal-title="Politiek" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/377a6fd273214a65bf79ee81cd01aa3e.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><span>Verschillende partijen, zoals de overheid, militairen, bedrijven, buurlanden …, strijden in Congo om macht, geld en grond.</span></td></tr></tbody></table></figure>">&nbsp;Politiek</a></td>\n     <td>&nbsp;</td>\n    </tr>\n    <tr>\n     <td style="text-align:right;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Ecologisch" data-modal-title="Ecologisch" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/2a7ac3743de147718675aa22628af20a.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><span>Kobalt wordt uit de grond gehaald in mijnen en de mijnindustrie breidt uit. Hierdoor wordt de natuur en het ecologische systeem verwoest.</span></td></tr></tbody></table></figure>">&nbsp;Ecologisch</a>&nbsp;</td>\n     <td rowspan="2">\n      <figure class="image image_resized" style="width:253px;">\n       <img style="aspect-ratio:2697/2972;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/3b9816e1b5cc476db79b2e3e9c93d17a.png" width="2697" height="2972">\n      </figure></td>\n     <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Economisch" data-modal-title="Economisch" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/917f3458e20945c3a0cd683e788fb830.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><span>Congo heeft veel natuurlijke rijkdommen, zoals kobalt. Deze grondstof is economisch zeer interessant, omdat ze in veel soorten elektronica gebruikt wordt.</span></td></tr></tbody></table></figure>">&nbsp;Economisch</a></td>\n    </tr>\n    <tr>\n     <td style="text-align:right;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Legaal" data-modal-title="Legaal" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/b1d799c3bf2d4f7ea6f13d2621ca0445.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><span>Er zijn klachten over kinderarbeid en (seksueel) geweld.</span></td></tr></tbody></table></figure>">&nbsp;Legaal</a>&nbsp;</td>\n     <td><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Sociaal" data-modal-title="Sociaal" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/46f1f8cbdd3c4b11992d98f5b7fb0409.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><p><span>Er is sprake van onmenselijke situaties in Congo. In de mijnen werken is gevaarlijk en ongezond, omdat er giftige stoffen in de grond zitten.</span></p><p><span>Ook de lokale bevolking komt onder druk te staan, omdat de mijnindustrie steeds uitbreidt. Hierdoor worden huizen en landbouwgronden worden vernietigd.</span></p><p><span>De politieke onenigheid leidt tot oorlog en veel mensen moeten op de vlucht gaan.</span></p></td></tr></tbody></table></figure>">&nbsp;Sociaal</a>&nbsp;</td>\n    </tr>\n    <tr>\n     <td>&nbsp;</td>\n     <td style="text-align:center;"><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Technologisch" data-modal-title="Technologisch" data-modal-size="M" data-modal-content="<figure class=&quot;table&quot;><table><tbody><tr><td style=&quot;width:30%;&quot;><span class=&quot;image-inline ck-widget ck-widget_with-resizer ck-widget_selected&quot; contenteditable=&quot;false&quot;><img class=&quot;image_resized&quot; style=&quot;aspect-ratio:2697/2706;width:253px;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images/c1ac5c96112a48689b88804facb53757.png&quot; width=&quot;2697&quot; height=&quot;2706&quot;></span></td><td><span>Kobalt wordt gebruikt in allerlei soorten elektronica, zoals smartphone-batterijen, elektrische wagens en vapes.</span></td></tr></tbody></table></figure>">&nbsp;Technologisch</a>&nbsp;</td>\n     <td>&nbsp;</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2123044',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 43,
    time: null,
    title: '2.1 Lezen: Worden onze rechten overal nageleefd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="">\n </div>\n <h2 class="dotted-in-editor">2.2 Leerling-Expert aan het woord!</h2>\n <h3 class="ck5h3">Sterk een standpunt innemen</h3>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Na deze opdracht kan je geïnformeerd een standpunt innemen over mensen- kinderrechten.</td>\n     <td style="width:40%;">15-20 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>Na de vorige opdrachten ben je een echte mensen- en kinderrechten expert! Tijd om jouw mening te geven.</p>\n <ul>\n  <li>Kies eerst een mensen- en kinderrecht.</li>\n  <li>Beantwoord de vragen door een standpunt in te nemen.</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116949',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 44,
    time: null,
    title: '2.2 oefenen: Leerling-expert aan het woord!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.2 leerling-expert aan het woord</h2>\n<h3 class="ck5h3">Sterk een standpunt innemen</h3>\n<p>In de vorige opdracht ging je aan de slag met een Instagrampost over de situatie in Congo. Een van de partijen is Amnesty International. De organisatie haalt correct aan dat er mensen- en kinderrechten geschonden worden. Bekijk de post nogmaals en kies een recht. Klik op volgende link voor een overzicht van de rechten:&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.amnesty-international.be/uvrm"> Overzicht mensenrechten </a>.</p>\n<p class="title-with-background title-with-background--question">Vraag 1: Welk recht heb je gekozen?</p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p>&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://www.instagram.com/p/C0UFLnUI0Ww/?img_index=1"> nws.nws.nws</a>&nbsp;</p>',
        id: '5702',
        title: 'NwsNwsNws post',
      },
    ],
    id: '2121246',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '351070',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 45,
    time: null,
    title: '2.2 Oefenen: Leerling-expert aan het woord',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.2 leerling-expert aan het woord!</h2>\n<h3 class="ck5h3">Sterk een standpunt innemen</h3>\n<p class="title-with-background title-with-background--question">Vraag 2: Waarom vind je dit een belangrijk mensenrecht?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117076',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350201',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 46,
    time: null,
    title: '2.2 oefenen: Leerling-expert aan het woord!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.2 leerling-expert aan het woord!</h2>\n<h3 class="ck5h3">Sterk een standpunt innemen</h3>\n<p class="title-with-background title-with-background--question">Vraag 3: Is dit een recht dat in België nageleefd wordt? Leg uit.</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117324',
    info: null,
    method: null,
    module: null,
    motivation: 'Zoek het laatste nieuws op over jouw gekozen recht.',
    part: null,
    questions: [
      {
        id: '350202',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 47,
    time: null,
    title: '2.2 oefenen: Leerling-expert aan het woord!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.2 leerling-expert aan het woord!</h2>\n<h3 class="ck5h3">Sterk een standpunt innemen</h3>\n<p class="title-with-background title-with-background--question">Vraag 4: Wat vind je ervan dat er ook kinderen moeten werken in de kobaltmijnen?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117325',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350203',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 48,
    time: null,
    title: '2.2 oefenen: Leerling-expert aan het woord!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">2.2 leerling-expert aan het woord!</h2>\n<h3 class="ck5h3">Sterk een standpunt innemen</h3>\n<p class="title-with-background title-with-background--question">Vraag 5: Wat vind je ervan dat kinderen uit hun huizen gezet worden om plaats te maken voor kobaltmijnen?</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117326',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350204',
        placeholder: null,
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: '',
      },
    ],
    sequence: 49,
    time: null,
    title: '2.2 oefenen: Leerling-expert aan het woord!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h2 class="dotted-in-editor">Test jezelf!</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/d7ec4ff56688477d8f348e062a1f278a.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120851',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 50,
    time: null,
    title: 'Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFWhiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/0853b08264c749fe96f160f45c6effd0.png" alt="">\n </div>\n <h2 class="dotted-in-editor">Test jezelf!</h2>\n <h3 class="ck5h3">Heb je het begrepen?</h3>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td style="width:60%;"><strong>Doelen</strong></td>\n     <td style="width:40%;"><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td style="width:60%;">Herhaal de leerstof van de les.</td>\n     <td style="width:40%;">5 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>Heb je de leerstof goed begrepen? Test het via deze opdracht.</p>\n <ul>\n  <li>Beantwoord de meerkeuzevragen op de volgende slides.</li>\n </ul>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116951',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 51,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<h3 class="ck5h3">Heb je het begrepen?</h3>\n<p class="title-with-background title-with-background--question">Vraag 1: Welke organisatie heeft als opdracht de mensen- en kinderrechten wereldwijd te beschermen en te bevorderen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117329',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350206',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1127263',
            numbering: null,
            value: '<p>Greenpeace</p>',
          },
          {
            id: '1127264',
            numbering: null,
            value: '<p>Amnesty International</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127265',
            numbering: null,
            value: '<p>Verenigde Naties</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 52,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<h3 class="ck5h3">Heb je het begrepen?</h3>\n<p class="title-with-background title-with-background--question">Vraag 2: Wanneer is de Universele Verklaring van de Rechten van de Mens ontstaan?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117330',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350207',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1127266',
            numbering: null,
            value: '<p>1895</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127267',
            numbering: null,
            value: '<p>1948</p>',
          },
          {
            id: '1127268',
            numbering: null,
            value: '<p>1989</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 53,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<h3 class="ck5h3">Heb je het begrepen?</h3>\n<p class="title-with-background title-with-background--question">Vraag 3: De Universele Verklaring van de Rechten van de Mens zegt dat mensen op basis van geslacht verschillende rechten hebben. Waar of niet waar?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117331',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350208',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1127269',
            numbering: null,
            value: '<p>Waar</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127270',
            numbering: null,
            value: '<p>Niet waar</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 54,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<h3 class="ck5h3">Heb je het begrepen?</h3>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 4: Hoeveel kinderrechten bestaan er?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117074',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350125',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1127257',
            numbering: null,
            value: '<p>41</p>',
          },
          {
            id: '1127258',
            numbering: null,
            value: '<p>54</p>',
          },
          {
            id: '1127259',
            numbering: null,
            value: '<p>31</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 55,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<h3 class="ck5h3">Heb je het begrepen?</h3>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Vraag 5: Wanneer is het Kinderrechtenverdrag er gekomen?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117075',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350126',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1127260',
            numbering: null,
            value: '<p>1989</p>',
          },
          {
            id: '1127261',
            numbering: null,
            value: '<p>1948</p>',
          },
          {
            id: '1127262',
            numbering: null,
            value: '<p>1945</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 56,
    time: null,
    title: 'Herhalen: Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Reflectie</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <a href="https://codefeverpublic.blob.core.windows.net/public-content/images/e645a33b3d3e4b9e8b5ff03478760bba.svg"><img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e645a33b3d3e4b9e8b5ff03478760bba.svg" alt=""></a>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116803',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 57,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van de les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--statement">Ik kan beschrijven wat mensen-en kinderrechten zijn.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2118011',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350287',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1127480',
            numbering: null,
            value:
              '<p><strong>Helemaal niet goed 😵‍💫</strong></p>\n<p>Ik heb geen idee wat mensen- en kinderrechten zijn.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127481',
            numbering: null,
            value:
              '<p><strong>Niet goed 🫤</strong></p>\n<p>Ik weet dat deze rechten bestaan, maar kan er niets over vertellen.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127482',
            numbering: null,
            value:
              '<p><strong>Bijna ✍️</strong></p>\n<p>Ik begrijp wat mensenrechten zijn, maar waarom zijn er ook kinderrechten?</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127483',
            numbering: null,
            value:
              '<p><strong>Goed </strong>👍</p>\n<p>Ik kan de belangrijkste zaken over mensen- en kinderrechten vertellen.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1127484',
            numbering: null,
            value:
              '<p><strong>Zeer goed 👑</strong></p>\n<p>Ik kan je alles vertellen over mensen- en kinderrechten!</p>',
          },
        ],
        scorePerCorrectAnswer: '0',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 58,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van de les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--statement">Ik kan toelichten dat mensen- en kinderrechten deel zijn van een groter systeem, waarin verschillende belangen met elkaar botsen.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120852',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350960',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1128970',
            numbering: null,
            value:
              '<p><strong>Helemaal niet goed 😵‍💫</strong></p>\n<p>Ik weet niet eens wat mensen- en kinderrechten zijn …</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128971',
            numbering: null,
            value:
              '<p><strong>Niet goed 🫤</strong></p>\n<p>Ik ken deze rechten, maar snap niet hoe ze deel zijn van een groter systeem.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128972',
            numbering: null,
            value:
              '<p><strong>Bijna </strong>✍️</p>\n<p>Ik begrijp dat deze rechten deel uitmaken van een groter systeem, maar kan niet uitleggen waarom.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128973',
            numbering: null,
            value:
              '<p><strong>Goed 👍</strong></p>\n<p>Ik begrijp dat deze rechten deel uitmaken van onze complexe maatschappij en kan voorbeelden geven van verschillende belangen.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128974',
            numbering: null,
            value:
              '<p><strong>Zeer goed 👑</strong></p>\n<p>Geef mij een probleemsituatie, en ik kan je een uitgebreide PESTLE-analyse geven van waar het overal fout liep.</p>',
          },
        ],
        scorePerCorrectAnswer: '0',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 59,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van de les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--statement">Ik kan geïnformeerd een standpunt innemen over kinderrechten.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2120854',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '350961',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1128975',
            numbering: null,
            value:
              '<p><strong>Helemaal niet goed 😵‍💫</strong></p>\n<p>Ik heb helemaal geen mening over kinderrechten.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128976',
            numbering: null,
            value:
              '<p><strong>Niet goed 🫤</strong></p>\n<p>Ik heb een mening over kinderrechten, maar kan/wil daar geen verdere uitleg bij geven.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128977',
            numbering: null,
            value:
              '<p><strong>Bijna </strong>✍️</p>\n<p>Ik heb een mening over kinderrechten. Ik probeer ook uit te leggen waarom ik er zo over denk, maar dit is nog moeilijk.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128978',
            numbering: null,
            value:
              'correct: true,' +
              'explanation: "<,p><strong>Goed 👍</strong></p>\n<p>Ik heb een eigen mening gevormd over kinderrechten' +
              ' en' +
              ' kan' +
              ' deze' +
              ' mening met du' +
              'idelijke standpunten toelichten.</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1128979',
            numbering: null,
            value:
              '<p><strong>Zeer goed 👑</strong></p>\n<p>Ik ben volledig klaar om in debat te gaan over kinderrechten. Ik wil het standpunt van andere mensen horen en in dialoog gaan.</p>',
          },
        ],
        scorePerCorrectAnswer: '0',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: null,
      },
    ],
    sequence: 60,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Doelen en leerwijzer</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2d605d30be554644850bd5f840b745a0.svg" alt="">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2116805',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 61,
    time: null,
    title: 'Doelen en leerwijzer',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div>\n <h2 class="dotted-in-editor">Doelen en leerwijzer</h2>\n <div class="learnContainer">\n  <div class="mainContent dotted-in-editor">\n   <h3>Na deze les kan je…</h3>\n   <div class="check-list">\n    <ul>\n     <li>beschrijven wat mensen- en kinderrechten zijn.</li>\n     <li>toelichten dat mensen- en kinderrechten deel zijn van een groter systeem, waarin verschillende belangen met elkaar botsen.</li>\n     <li>geïnformeerd een standpunt innemen over kinderrechten.</li>\n    </ul>\n   </div>\n   <h3 class="ck5h3">&nbsp;</h3>\n   <h3 class="ck5h3">Download hier de leerwijzer van deze les</h3>\n   <p>&nbsp;&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__DownloadLink cursor-pointer select-none mb-2" download-file-name="WIJS_IedereenGelijk_L1_HetComplexeSysteemVanMensenEnKinderrechten_Leerwijzer" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/550bacb1a76340b0ada1915a0fabb3e6.pdf"> Leerwijzer</a>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <div class="ftrprfLogo">\n    &nbsp;\n   </div>\n  </div>\n  <div class="dotted-in-editor imagePlaceholder">\n   <span><strong><img class="image_resized" style="width:380px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ccab545807814205b8ad7edc30ff00ee.jpg" alt=""></strong></span>\n  </div>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2117524',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 62,
    time: null,
    title: 'Doelen en leerwijzer',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Geef jouw feedback!</h2>\n<p>We horen heel graag wat jij van deze les vond.&nbsp;</p>\n<p><a class="styledLink SlideViewer__StyledButton SlideViewer__ExternalLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" data-href="https://wkf.ms/42IGUn8">&nbsp;Geef jouw feedback hier.</a>&nbsp;</p>\n<p>&nbsp;</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2124111',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 63,
    time: null,
    title: 'Geef hier jouw feedback!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
];
